import { Button, Checkbox, Modal, Tree } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { accountHandle } from "../../Account/state/actions";

const BOSModal = ({ openModal, setOpenModal, checkedBrokerageGroupId }) => {
  const [intitialValues, setIntitialValues] = useState({});
  const { allBackOfficeData } = useSelector((state) => state.account);

  useEffect(()=>{
    const ner = structuredClone(allBackOfficeData);
    for(let group of ner){
      if(group.checked){
        setIntitialValues({...group});
        break;
      }
    }
  }, [allBackOfficeData]);

  const dispatch = useDispatch();

  const handleCancel = () => {
    setOpenModal({ ...openModal, isModalOpen: false });
  };

  const handleCheckBoxChange = (e, id) => {
    let checked = e.target.checked;
    let cloneValue = {
      ...intitialValues
    }
    for(let i=0 ; i<(cloneValue?.parentData?.length || []); i++){
      const brokerage = cloneValue?.parentData[i];
      if(brokerage?._id === id){
        if(checked) brokerage.checked = true;
        else brokerage.checked = false;
        break;
      }
      let found = false;
      for(let j=0 ; j<(brokerage?.parentData?.length || []); j++){
        const office = brokerage?.parentData[j];
        if(office?._id === id){
          if(checked) office.checked = true;
          else office.checked = false;
          found = true;
          break;
        };
      }
      if(found) break;
    }
    setIntitialValues(cloneValue);
  }

  const handleBos = () => {
    setOpenModal({ ...openModal, isModalOpen: false });
    dispatch(accountHandle.handleCheckBosFirms({data: intitialValues}));
  };

  return (
    <Modal
      open={openModal}
      title={<div className="commonModalTitle">{intitialValues?.name || ""}</div>}
      onCancel={handleCancel}
      footer={false}
    >
      { (Array.isArray(intitialValues?.parentData) && (intitialValues?.parentData?.length > 0)) && <div>
        {
          intitialValues?.parentData?.map((brokerage)=>{
            return <div>
              <Checkbox style={{ color: "#7f8082", fontSize: "16px", fontWeight: "600" }} checked={brokerage?.checked} onChange={(checked)=>handleCheckBoxChange(checked, brokerage?._id)}>
                {brokerage?.name} {(brokerage?.type === "BROKERAGE") ? <>- <span style={{color: "blue"}}>Brokerage</span></> : ''}
              </Checkbox>
              <div style={{marginLeft: "25px"}}>
                {
                  brokerage?.parentData?.map((office)=>{
                    return <Checkbox style={{ color: "#7f8082", fontSize: "16px", fontWeight: "600" }} checked={office?.checked} onChange={(checked)=>handleCheckBoxChange(checked, office?._id)}>
                      {office?.name} {(office?.type === "OFFICE") ? <>- <span style={{color: "green"}}>Office</span></> : ''}
                    </Checkbox>
                  })
                }
              </div>
            </div>
          })
        }
        <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "20px" }}>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button type="primary" onClick={handleBos} disabled={(checkedBrokerageGroupId([intitialValues]))?.length === 0}>
            Save
          </Button>
        </div>
      </div>}
    </Modal>
  );
};

export default BOSModal;